import Checkmark from "@/components/common/icons/checkmark"
import cx from "classnames"
import { AnimatePresence, motion } from "framer-motion"

function Input({ label, value, checked, onChange }) {
  return (
    <label
      className={cx(
        "flex items-center bg-white h-14 rounded-[64px] px-4 cursor-pointer border-2 border-summer-green-50 transition-colors duration-200 hover:border-summer-green-100",
        { "bg-transparent border-summer-green-100": checked }
      )}>
      <input
        checked={checked}
        value={value}
        type="checkbox"
        className="opacity-0 absolute"
        onChange={onChange}
      />

      <div
        className={cx(
          "flex items-center justify-center w-6 h-6 border-2 border-summer-green-100 rounded-full mr-2 transition-colors duration-150",
          {
            "bg-summer-green-100": checked
          }
        )}>
        <AnimatePresence>
          {checked && (
            <motion.div
              initial={{ scale: 0, opacity: 0.5 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}>
              <Checkmark className="w-3" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <span className="text-sm select-none">{label}</span>
    </label>
  )
}

export default Input
